const initialState = {};
// to be expanded
const config = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'SAVE_CONFIG': {
      return {
        ...state,
        ...action.data,
      };
    }
    default:
      return state;
  }
};

export default config;
